export const COURSE_ALL_INSTRUCTOR = 'course_all_instructor';
export const COURSE_DETAIL = 'course_detail';
export const COURSE_LESSONPAGE = 'course_lessonpage';
export const COURSE_PLAYER = 'course_player';
export const MY_LEARNING = 'my_learning';

export const MATERIALS_TAB = 'materials_tab';
export const LESSON = 'lesson';
